import { atom } from "jotai";

interface HypothesisToolbarAtomInterface {
    hypothesisIdToshowCommentPopup: string;
};

const INITIAL_HYPOTHESIS_TOOLBAR_ATOM_VALUE: HypothesisToolbarAtomInterface = {
    hypothesisIdToshowCommentPopup: null,
};

export const hypothesisToolbarAtom = atom(INITIAL_HYPOTHESIS_TOOLBAR_ATOM_VALUE);

export const setHypothesisIdToshowCommentPopup = (set: Function, hypothesisID: string) => {
    set((atomState: HypothesisToolbarAtomInterface) => {
        const newState = {...atomState};

        newState.hypothesisIdToshowCommentPopup = hypothesisID;

        return newState;
    })
};
